export class InitiationUrlConstants {

  public static readonly GET_MARS_QRM =
    './../../../assets/json-constant/mars_qrm.json';
  public static readonly GET_INDUSTRY_LEADER =
    './../../../assets/json-constant/mars_IndustryLeader.json';

}
